import { listTvs, revokeTv, tvOnline, type TvDevice } from '@gymtv/data';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { supabase } from '../lib/supabase';

export function Settings() {
  const { session, units, setUnits, signOut } = useAuth();
  const [tvs, setTvs] = useState<TvDevice[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const load = () => listTvs(supabase).then(setTvs, (e) => setError(e.message));
  useEffect(() => {
    load();
  }, []);

  return (
    <>
      <div className="page-head">
        <h1>Settings</h1>
      </div>
      {error && <p className="error">{error}</p>}
      <section className="card stack">
        <h2>Account</h2>
        <p>{session?.user.email}</p>
        <div className="row">
          <span>Units</span>
          <div className="tabs" role="group" aria-label="Units">
            {(['kg', 'lb'] as const).map((u) => (
              <button key={u} aria-pressed={units === u} onClick={() => setUnits(u)}>
                {u}
              </button>
            ))}
          </div>
          <span className="hint">The TV remote changes weight by 2.5 kg or 5 lb.</span>
        </div>
        <div>
          <button onClick={signOut}>Sign out</button>
        </div>
      </section>
      <section className="card stack">
        <div className="row" style={{ justifyContent: 'space-between' }}>
          <h2>TVs</h2>
          <Link className="btn" to="/pair">Pair a TV</Link>
        </div>
        {tvs?.length === 0 && <p className="muted">No TVs paired.</p>}
        {tvs?.map((tv) => (
          <div key={tv.id} className="row" style={{ justifyContent: 'space-between', borderTop: '1px solid var(--line)', paddingTop: 10 }}>
            <div>
              <b>{tv.name}</b>{' '}
              <span className={`pill ${tvOnline(tv) ? 'ok' : ''}`}>{tvOnline(tv) ? 'online' : 'offline'}</span>
              <div className="muted">{tv.platform ?? 'TV'} · paired {new Date(tv.paired_at).toLocaleDateString()}</div>
            </div>
            <button
              className="danger"
              onClick={() => {
                if (window.confirm(`Unpair “${tv.name}”? It will show a new pairing code.`)) revokeTv(supabase, tv.id).then(load, (e) => setError(e.message));
              }}
            >
              Unpair
            </button>
          </div>
        ))}
      </section>
    </>
  );
}
